/**
 * Configuration de l'URL de l'API backend
 * 
 * En production, configurez la variable d'environnement REACT_APP_API_URL dans Vercel
 * ou modifiez l'URL par défaut ci-dessous.
 */

const getApiUrl = (): string => {
  // 1. Vérifier la variable d'environnement
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Détecter l'environnement
  const isProduction = typeof window !== 'undefined' && 
    window.location.hostname !== 'localhost' && 
    window.location.hostname !== '127.0.0.1';

  if (isProduction) {
    // En production, utiliser l'URL relative si le backend est sur le même domaine
    // Sinon, utiliser REACT_APP_API_URL ou l'URL par défaut
    const defaultProductionUrl = process.env.REACT_APP_API_URL || 
      (typeof window !== 'undefined' ? window.location.origin : '');
    
    // Si REACT_APP_API_URL n'est pas configuré, utiliser l'URL relative
    if (!process.env.REACT_APP_API_URL) {
      console.warn('⚠️ REACT_APP_API_URL non configuré en production');
      console.warn('⚠️ Utilisation de l\'URL relative (même domaine)');
      console.warn('⚠️ Pour utiliser un backend séparé, configurez REACT_APP_API_URL dans Vercel');
      
      // Retourner une URL relative pour le même domaine
      return '';
    }
    
    return defaultProductionUrl;
  }

  // 3. URL par défaut en développement
  return 'http://localhost:3001';
};

export const API_URL = getApiUrl();

// Fonction helper pour les appels API avec gestion d'erreur améliorée
export const apiFetch = async (
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> => {
  const url = `${API_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    return response;
  } catch (error) {
    console.error(`❌ Erreur de connexion à ${url}:`, error);
    throw new Error(
      `Impossible de se connecter au serveur (${url}). ` +
      `Vérifiez que le backend est accessible et que REACT_APP_API_URL est correctement configuré.`
    );
  }
};

